var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"span":24}},[_c('div',{ref:"chart",staticClass:"CoreChart-num1"})])}
var staticRenderFns = []

export { render, staticRenderFns }